<template>


    <nav class="cf-menutop" ref="menuroot">
        <div class="cf-menu-inner">

            <a href="javascript:void(0);" class="cf-menutop__brand">
                <i class="ri-settings-3-line"></i> Paramètres
            </a>

            <!-- Bascule mobile -->
            <button @click="toggleNavbar" type="button" class="cf-menu-burger" :aria-expanded="isNavbarOpen.toString()">
                <span class="sr-only">Ouvrir le menu</span>
                <i class="ri-menu-line"></i>
            </button>

            <div :class="{ 'hidden': !isNavbarOpen, 'block': isNavbarOpen }" class="cf-menu-collapse" id="navbar-dropdown">
                <ul class="cf-menu-list">

                    <!-- Caisse -->
                    <li class="cf-menu-dd">
                        <button type="button" class="cf-menu-btn" :class="{ 'cf-menu-btn--on': openMenu === 'caisse' }" @click="toggleMenu('caisse')">
                            <i class="ri-cash-line cf-menu-icon"></i> Caisse
                            <i class="ri-arrow-down-s-line cf-menu-caret" :class="{ 'cf-menu-caret--on': openMenu === 'caisse' }"></i>
                        </button>
                        <transition name="cf-menu-fade">
                            <div v-show="openMenu === 'caisse'" class="cf-menu-pop cf-menu-scroll">
                                <button type="button" class="cf-menu-item" @click="btnmodalindexcaisse(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-safe-2-line"></i> Créer une caisse
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalindexbanque(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-bank-line"></i> Créer une banque
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalindexaccesscaisse(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-key-2-line"></i> Donner / Retirer un accès sur une caisse
                                </button>
                            </div>
                        </transition>
                    </li>

                    <!-- Utilisateur -->
                    <li class="cf-menu-dd">
                        <button type="button" class="cf-menu-btn" :class="{ 'cf-menu-btn--on': openMenu === 'user' }" @click="toggleMenu('user')">
                            <i class="ri-user-settings-line cf-menu-icon"></i> Utilisateur
                            <i class="ri-arrow-down-s-line cf-menu-caret" :class="{ 'cf-menu-caret--on': openMenu === 'user' }"></i>
                        </button>
                        <transition name="cf-menu-fade">
                            <div v-show="openMenu === 'user'" class="cf-menu-pop cf-menu-scroll">
                                <button type="button" class="cf-menu-item" @click="btnmodalprofiluser(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-shield-user-line"></i> Créer un profil / accès pages
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalindexutilisateur(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-user-add-line"></i> Créer un utilisateur
                                </button>
                            </div>
                        </transition>
                    </li>

                    <!-- Espace disque -->
                    <li>
                        <button type="button" class="cf-menu-btn" @click="btnmodalespacedisk(); openMenu = null; isNavbarOpen = false">
                            <i class="ri-hard-drive-2-line cf-menu-icon"></i> Espace disque
                        </button>
                    </li>

                    <!-- Utilitaires -->
                    <li class="cf-menu-dd">
                        <button type="button" class="cf-menu-btn" :class="{ 'cf-menu-btn--on': openMenu === 'uti' }" @click="toggleMenu('uti')">
                            <i class="ri-tools-line cf-menu-icon"></i> Utilitaires
                            <i class="ri-arrow-down-s-line cf-menu-caret" :class="{ 'cf-menu-caret--on': openMenu === 'uti' }"></i>
                        </button>
                        <transition name="cf-menu-fade">
                            <div v-show="openMenu === 'uti'" class="cf-menu-pop cf-menu-scroll">
                                <button type="button" class="cf-menu-item" @click="btnnormalisationextrafacture(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-file-settings-line"></i> Normalisation extra de facture
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnutilitairemiseajourpointsurletatdepaiement(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-refresh-line"></i> Caisse / Mise à jour des points de caisse sur les états de paiement
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnutilitairemiseajoureclatementdesoperationscaisse(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-split-cells-horizontal"></i> Caisse / Mise à jour éclatement des opération de caisse sur une date à parti d'un référentiel d'opération
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnutilitairemiseajouretatdepaiement(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-refresh-line"></i> Caisse / Mise à jour des états de paiement
                                </button>
                            </div>
                        </transition>
                    </li>


                </ul>
            </div>
        </div>
    </nav>


    <modalindexcaisse ref="modalindexcaisse"></modalindexcaisse>
    <modalindexbanque ref="modalindexbanque"></modalindexbanque>
    <modalindexaccesscaisse ref="modalindexaccesscaisse"></modalindexaccesscaisse>
    <modalindexutilisateur ref="modalindexutilisateur"></modalindexutilisateur>
    <modalprofiluser ref="modalprofiluser"></modalprofiluser>


    <utilitairemiseajouretatdepaiement ref="utilitairemiseajouretatdepaiement"></utilitairemiseajouretatdepaiement>
    <utilitairemiseajourpointsurletatdepaiement ref="utilitairemiseajourpointsurletatdepaiement"></utilitairemiseajourpointsurletatdepaiement>
    <utilitairemiseajoureclatementdesoperationscaisse ref="utilitairemiseajoureclatementdesoperationscaisse"></utilitairemiseajoureclatementdesoperationscaisse>
    <utilitairenormalisationextra ref="utilitairenormalisationextra"></utilitairenormalisationextra>
    <modalespacedisk ref="modalespacedisk"></modalespacedisk>


</template>


<script>

    import modalindexcaisse from "@/components/views/pages/setting/caisse/index";
    import modalindexbanque from "@/components/views/pages/setting/banque/index";
    import modalindexaccesscaisse from "@/components/views/pages/setting/accesscaisse/index";
    import modalindexutilisateur from "@/components/views/pages/setting/utilisateur/index";
    /*import modalprofiluser from "@/components/views/pages/setting/profiluser/index";*/
    import modalprofiluser from "@/components/views/pages/setting/profiluser/profilmanager";
    import utilitairemiseajouretatdepaiement from "@/components/views/pages/setting/utilitaires/caisse/modal_miseajouretatdepaiement";
    import utilitairemiseajoureclatementdesoperationscaisse from "@/components/views/pages/setting/utilitaires/caisse/modal_miseajoureclatementdesoperationscaisse";
    import utilitairemiseajourpointsurletatdepaiement from "@/components/views/pages/setting/utilitaires/caisse/modal_miseajourPointsurletatdepaiement";
    import utilitairenormalisationextra from "@/components/views/pages/setting/utilitaires/noramlisationextra/index";
    import modalespacedisk from "@/components/views/pages/setting/modal_espacedisk";






    export default {
        /* eslint-disable */
        name: "mymenu",
        data() {
            return {
                isNavbarOpen: false,
                isDropdownOpen: true,
                openMenu: null
            };
        },
        components: {
            modalindexcaisse,
            modalindexbanque,
            modalindexaccesscaisse,
            modalindexutilisateur,
            modalprofiluser,
            utilitairemiseajouretatdepaiement,
            utilitairemiseajoureclatementdesoperationscaisse,
            utilitairemiseajourpointsurletatdepaiement,
            utilitairenormalisationextra,
            modalespacedisk,

        },
        methods: {


            btnnormalisationextrafacture(){

                this.$refs.utilitairenormalisationextra.show();
            },

            btnmodalespacedisk(){

                this.$refs.modalespacedisk.show();
            },


            btnutilitairemiseajourpointsurletatdepaiement(){

                this.$refs.utilitairemiseajourpointsurletatdepaiement.show();
            },

            btnutilitairemiseajouretatdepaiement(){

                this.$refs.utilitairemiseajouretatdepaiement.show();
            },



            btnutilitairemiseajoureclatementdesoperationscaisse(){

                this.$refs.utilitairemiseajoureclatementdesoperationscaisse.show();
            },

            btnmodalprofiluser(){

                this.$refs.modalprofiluser.show();
            },

            btnmodalindexcaisse(){

                this.$refs.modalindexcaisse.show();
            },

            btnmodalindexutilisateur(){

                this.$refs.modalindexutilisateur.show();
            },

            btnmodalindexbanque(){

                this.$refs.modalindexbanque.show();
            },

            btnmodalindexaccesscaisse(){

                this.$refs.modalindexaccesscaisse.show();
            },



            toggleNavbar() {
                this.isNavbarOpen = !this.isNavbarOpen;
            },
            toggleDropdown() {

                this.isDropdownOpen = !this.isDropdownOpen;

            },

            // Plumbing menus manuels (remplace Preline hs-dropdown)
            toggleMenu(name) {
                this.openMenu = this.openMenu === name ? null : name;
            },
            handleGlobalClick(e) {
                const root = this.$refs.menuroot;
                if (root && !root.contains(e.target)) {
                    this.openMenu = null;
                }
            }
        },

        mounted() {
            document.addEventListener('click', this.handleGlobalClick);
        },

        beforeUnmount() {
            document.removeEventListener('click', this.handleGlobalClick);
        }
    };
</script>

<style scoped>
    /* Charte cf-/ds- : barre de menu du module Paramètres (light-only) */
    .cf-menutop {
        margin-top: 4% !important;
        background: #fff;
        border: 1px solid rgb(var(--default-border));
        border-radius: var(--cf-radius);
        box-shadow: var(--cf-shadow-sm);
    }
    @media screen and (max-width: 800px) { .cf-menutop { margin-top: 12.5% !important; } }

    .cf-menu-inner {
        display: flex; flex-wrap: wrap; align-items: center; gap: 0.5rem 1rem;
        padding: 0.6rem 1rem; max-width: 1280px; margin: 0 auto;
    }
    .cf-menutop__brand {
        display: inline-flex; align-items: center; gap: 0.5rem;
        font-weight: 700; font-size: 0.95rem; letter-spacing: -0.01em;
        color: rgb(var(--primary)); text-decoration: none;
    }
    .cf-menutop__brand i { font-size: 1.15rem; }

    .cf-menu-burger {
        margin-left: auto; height: 38px; width: 38px; border: 1px solid var(--cf-border);
        border-radius: var(--cf-radius-sm); background: #fff; color: var(--cf-muted);
        display: inline-flex; align-items: center; justify-content: center; font-size: 1.2rem; cursor: pointer;
    }
    .cf-menu-burger:hover { color: rgb(var(--primary)); border-color: rgb(var(--primary) / 0.35); }
    @media (min-width: 768px) { .cf-menu-burger { display: none; } }

    .cf-menu-collapse { width: 100%; }
    @media (min-width: 768px) { .cf-menu-collapse { display: block !important; width: auto; margin-left: auto; } }

    .cf-menu-list {
        display: flex; flex-direction: column; gap: 0.2rem; list-style: none;
        margin: 0.6rem 0 0; padding: 0;
    }
    @media (min-width: 768px) {
        .cf-menu-list { flex-direction: row; align-items: center; justify-content: flex-end; gap: 0.4rem; margin: 0; }
    }

    .cf-menu-dd { position: relative; }

    .cf-menu-btn {
        display: inline-flex; align-items: center; gap: 0.35rem; width: 100%;
        padding: 0.5rem 0.75rem; border-radius: var(--cf-radius-sm);
        font-weight: 600; font-size: 0.85rem; color: var(--cf-ink);
        background: transparent; border: 0; cursor: pointer; text-align: left;
        transition: color 0.18s ease, background-color 0.18s ease;
    }
    @media (min-width: 768px) { .cf-menu-btn { width: auto; } }
    .cf-menu-btn:hover { color: rgb(var(--primary)); background: rgb(var(--primary) / 0.07); }
    .cf-menu-btn--on { color: rgb(var(--primary)); background: rgb(var(--primary) / 0.10); }
    .cf-menu-icon { color: rgb(var(--primary)); font-size: 1rem; }
    .cf-menu-caret { margin-left: auto; font-size: 0.9rem; color: var(--cf-faint); transition: transform 0.18s ease; }
    @media (min-width: 768px) { .cf-menu-caret { margin-left: 0.15rem; } }
    .cf-menu-caret--on { transform: rotate(180deg); color: rgb(var(--primary)); }

    .cf-menu-pop {
        display: flex; flex-direction: column; gap: 1px;
        margin: 0.15rem 0 0.35rem 0.75rem; padding: 0.35rem;
        border-left: 2px solid var(--cf-border);
    }
    @media (min-width: 768px) {
        .cf-menu-pop {
            position: absolute; top: calc(100% + 6px); right: 0; left: auto; z-index: 40;
            min-width: 260px; margin: 0; padding: 0.4rem;
            background: #fff; border: 1px solid var(--cf-border); border-left: 1px solid var(--cf-border);
            border-radius: var(--cf-radius); box-shadow: var(--cf-shadow-md);
        }
    }
    .cf-menu-scroll { max-height: 70vh; overflow-y: auto; }
    @media (min-width: 768px) { .cf-menu-scroll { min-width: 340px; } }

    .cf-menu-item {
        display: flex; align-items: center; gap: 0.5rem; width: 100%;
        padding: 0.5rem 0.65rem; border-radius: var(--cf-radius-sm);
        font-size: 0.82rem; font-weight: 500; color: var(--cf-ink);
        background: transparent; border: 0; cursor: pointer; text-align: left;
        transition: background-color 0.15s ease, color 0.15s ease;
    }
    .cf-menu-item i { color: var(--cf-muted); font-size: 1rem; flex-shrink: 0; }
    .cf-menu-item:hover { background: rgb(var(--primary) / 0.08); color: rgb(var(--primary)); }
    .cf-menu-item:hover i { color: rgb(var(--primary)); }

    .cf-menu-fade-enter-active, .cf-menu-fade-leave-active { transition: opacity 0.15s ease, transform 0.15s ease; }
    .cf-menu-fade-enter-from, .cf-menu-fade-leave-to { opacity: 0; transform: translateY(-4px); }

    .sr-only {
        position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px;
        overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0;
    }

    button:focus { outline: 0 !important; }
</style>
